"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _styledComponents = require("styled-components");
var _lodash2 = _interopRequireDefault(require("lodash.isfunction"));
var _lodash3 = _interopRequireDefault(require("lodash.isobject"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenConstants = require("@8x8/oxygen-constants");
var _types = require("../constants/types");
var _themeName = _interopRequireDefault(require("../constants/themeName"));
var _InputIcon = _interopRequireDefault(require("../styled/InputIcon"));
var _InputField = _interopRequireDefault(require("../styled/InputField"));
var _InputWrapper = _interopRequireDefault(require("../styled/InputWrapper"));
var _InputDecorator = _interopRequireDefault(require("../styled/InputDecorator"));
var _InputFieldWrapper = _interopRequireDefault(require("../styled/InputFieldWrapper"));
var _excluded = ["theme", "id", "name", "value", "max", "min", "maxLength", "placeholder", "type", "autoComplete", "autoFocus", "size", "prefix", "suffix", "iconLeft", "iconRight", "fixed", "hasError", "isDisabled", "isReadOnly", "isRequired", "fullWidth", "onKeyUp", "onKeyDown", "onChange", "onFocus", "onBlur", "forwardedRef", "testId", "autoPrefixWidth", "autoSuffixWidth", "inputProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Input = /*#__PURE__*/function (_PureComponent) {
  _inherits(Input, _PureComponent);
  var _super = _createSuper(Input);
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false
    });
    _defineProperty(_assertThisInitialized(_this), "setInputFieldRef", function (element) {
      var inputRef = _this.props.inputRef;
      _this.inputFieldRef = element;
      if ((0, _lodash2["default"])(inputRef)) {
        inputRef(element);
      }
      if ((0, _lodash3["default"])(inputRef)) {
        inputRef.current = element;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "inputFieldRef", null);
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      _this.setState({
        focused: true
      });
      _this.props.onFocus(event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      _this.setState({
        focused: false
      });
      _this.props.onBlur(event);
    });
    return _this;
  }
  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focus && this.inputFieldRef) {
        this.inputFieldRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        id = _this$props.id,
        name = _this$props.name,
        value = _this$props.value,
        max = _this$props.max,
        min = _this$props.min,
        maxLength = _this$props.maxLength,
        placeholder = _this$props.placeholder,
        type = _this$props.type,
        autoComplete = _this$props.autoComplete,
        autoFocus = _this$props.autoFocus,
        size = _this$props.size,
        prefix = _this$props.prefix,
        suffix = _this$props.suffix,
        IconLeft = _this$props.iconLeft,
        IconRight = _this$props.iconRight,
        fixed = _this$props.fixed,
        hasError = _this$props.hasError,
        isDisabled = _this$props.isDisabled,
        isReadOnly = _this$props.isReadOnly,
        isRequired = _this$props.isRequired,
        fullWidth = _this$props.fullWidth,
        onKeyUp = _this$props.onKeyUp,
        onKeyDown = _this$props.onKeyDown,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        forwardedRef = _this$props.forwardedRef,
        testId = _this$props.testId,
        autoPrefixWidth = _this$props.autoPrefixWidth,
        autoSuffixWidth = _this$props.autoSuffixWidth,
        inputProps = _this$props.inputProps,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var focused = this.state.focused;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_InputWrapper["default"], _extends({}, (0, _oxygenConfig.getTestAttributes)(testId), {
        ref: forwardedRef,
        size: size,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        fixed: fixed,
        fullWidth: fullWidth
      }, otherProps), prefix && !theme.prefixSuffixInsideInput && /*#__PURE__*/_react["default"].createElement(_InputDecorator["default"], {
        focused: focused,
        hasError: hasError,
        isReadOnly: isReadOnly,
        autoWidth: autoPrefixWidth,
        isPrefix: !!prefix
      }, /*#__PURE__*/_react["default"].createElement("span", null, prefix)), /*#__PURE__*/_react["default"].createElement(_InputFieldWrapper["default"], {
        withPrefix: !!prefix,
        withSuffix: !!suffix,
        fixed: fixed,
        isReadOnly: isReadOnly,
        focused: focused,
        hasError: hasError,
        iconLeft: !!IconLeft,
        iconRight: !!IconRight
      }, prefix && theme.prefixSuffixInsideInput && /*#__PURE__*/_react["default"].createElement(_InputDecorator["default"], {
        focused: focused,
        hasError: hasError,
        isReadOnly: isReadOnly,
        autoWidth: autoPrefixWidth,
        isPrefix: !!prefix
      }, /*#__PURE__*/_react["default"].createElement("span", null, prefix)), IconLeft && /*#__PURE__*/_react["default"].createElement(_InputIcon["default"], null, /*#__PURE__*/_react["default"].createElement(IconLeft, {
        size: theme.iconSize,
        color: !(value !== null && value !== void 0 && value.length) ? theme.colorPlaceholder : theme.colorIcon
      })), /*#__PURE__*/_react["default"].createElement(_InputField["default"], _extends({
        ref: this.setInputFieldRef,
        id: id,
        max: max,
        min: min,
        maxLength: maxLength,
        "aria-disabled": isDisabled,
        "aria-invalid": hasError,
        "aria-required": isRequired,
        "aria-readonly": isReadOnly,
        name: name,
        type: type,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        value: value,
        placeholder: placeholder,
        fixed: fixed,
        readOnly: isReadOnly,
        disabled: fixed || isDisabled,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onChange: onChange
      }, inputProps, {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      })), IconRight && /*#__PURE__*/_react["default"].createElement(_InputIcon["default"], {
        marginLeft: true
      }, /*#__PURE__*/_react["default"].createElement(IconRight, {
        size: theme.iconSize,
        color: !(value !== null && value !== void 0 && value.length) ? theme.colorPlaceholder : theme.colorIcon
      })), suffix && theme.prefixSuffixInsideInput && /*#__PURE__*/_react["default"].createElement(_InputDecorator["default"], {
        autoWidth: autoSuffixWidth,
        focused: focused,
        hasError: hasError,
        isSuffix: !!suffix,
        isReadOnly: isReadOnly
      }, /*#__PURE__*/_react["default"].createElement("span", null, suffix))), suffix && !theme.prefixSuffixInsideInput && /*#__PURE__*/_react["default"].createElement(_InputDecorator["default"], {
        autoWidth: autoSuffixWidth,
        focused: focused,
        hasError: hasError,
        isSuffix: !!suffix,
        isReadOnly: isReadOnly
      }, /*#__PURE__*/_react["default"].createElement("span", null, suffix))));
    }
  }]);
  return Input;
}(_react.PureComponent);
_defineProperty(Input, "propTypes", {
  /**
   * Input theme
   */
  theme: _propTypes["default"].object.isRequired,
  /**
   * Define id attribute for input element
   */
  id: _propTypes["default"].string,
  /**
   * Define name attribute for input element
   */
  name: _propTypes["default"].string,
  /**
   * Value / Initial value of the input
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Define maximum value for input type number
   */
  max: _propTypes["default"].number,
  /**
   * Define minimum value for input type number
   */
  min: _propTypes["default"].number,
  /**
   * The input maximum number of characters
   */
  maxLength: _propTypes["default"].number,
  /**
   * Render placeholder text inside input
   */
  placeholder: _propTypes["default"].string,
  /**
   * Define autocomplete attribute for Input
   */
  autoComplete: _propTypes["default"].string,
  /**
   * Define autofocus attribute for Input
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * Define type of Input
   */
  type: _propTypes["default"].oneOf([_types.DATE, _types.EMAIL, _types.NUMBER, _types.PASSWORD, _types.TEL, _types.TEXT, _types.URL]),
  /**
   * Define Input size
   */
  size: _propTypes["default"].oneOf([_oxygenConstants.inputSize.small, _oxygenConstants.inputSize["default"], _oxygenConstants.inputSize.large]),
  /**
   * Show text in front of input
   */
  prefix: _propTypes["default"].string,
  /**
   * Show text just after input
   */
  suffix: _propTypes["default"].string,
  /**
   * Show icon inside input on the left side
   */
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  /**
   * Show icon inside input on the right side
   */
  iconRight: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  /**
   * Tell when Input is focus
   */
  focus: _propTypes["default"].bool,
  /**
   * Render input as pure text
   */
  fixed: _propTypes["default"].bool,
  /**
   * Tell when Input has error
   */
  hasError: _propTypes["default"].bool,
  /**
   * Tell when Input is disabled
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * Tell when Input is read only
   */
  isReadOnly: _propTypes["default"].bool,
  /**
   * Tell when Input is required
   */
  isRequired: _propTypes["default"].bool,
  /**
   * Tell when Input is stretched
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * Callback when the input change
   */
  onChange: _propTypes["default"].func,
  /**
   * Standard input onkeyup event
   */
  onKeyUp: _propTypes["default"].func,
  /**
   * Standard input onkeydown event
   */
  onKeyDown: _propTypes["default"].func,
  /**
   * Callback when input is blurred
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback when input is focused
   */
  onFocus: _propTypes["default"].func,
  /**
   * Forwarded ref
   */
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * Ref for input field
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * Test id
   */
  testId: _propTypes["default"].string,
  /**
   * Allows suffix to auto resize
   */
  autoSuffixWidth: _propTypes["default"].bool,
  /**
   * Allows prefix to auto resize
   */
  autoPrefixWidth: _propTypes["default"].bool,
  /**
   * Rest of props pass into InputField component
   */
  inputProps: _propTypes["default"].object
});
_defineProperty(Input, "defaultProps", {
  autoComplete: undefined,
  autoFocus: false,
  autoPrefixWidth: false,
  autoSuffixWidth: false,
  fixed: false,
  focus: false,
  forwardedRef: null,
  fullWidth: true,
  hasError: false,
  iconLeft: null,
  iconRight: null,
  id: undefined,
  inputRef: null,
  isDisabled: false,
  isReadOnly: false,
  isRequired: false,
  max: undefined,
  maxLength: undefined,
  min: undefined,
  name: undefined,
  onChange: _lodash["default"],
  onKeyDown: _lodash["default"],
  onKeyUp: _lodash["default"],
  onFocus: _lodash["default"],
  onBlur: _lodash["default"],
  placeholder: '',
  prefix: '',
  size: _oxygenConstants.inputSize["default"],
  suffix: '',
  testId: 'INPUT',
  type: _types.TEXT,
  value: undefined,
  inputProps: undefined
});
var _default = (0, _oxygenConfig.withTheme)(Input, _themeName["default"]);
exports["default"] = _default;